import { render, staticRenderFns } from "./_base-tree-select.vue?vue&type=template&id=5ecbfc08&scoped=true&"
import script from "./_base-tree-select.vue?vue&type=script&lang=js&"
export * from "./_base-tree-select.vue?vue&type=script&lang=js&"
import style0 from "./_base-tree-select.vue?vue&type=style&index=0&id=5ecbfc08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecbfc08",
  null
  
)

export default component.exports